import React, {useRef, useEffect} from 'react'
import axios from 'axios'
import SampleDataGrid from 'layouts/SampleDataGrid'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import Protocol from 'protocols/Protocol';
import { sampleNameComparator } from 'utils/utils';
import { Chip, Tooltip, styled, List } from '@mui/material';
import moment from 'moment';
import SampleNameAndBadge from 'components/SampleNameAndBadge';

const ListItem = styled('li')(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  listStyle: 'none',
  cursor: 'pointer',
}))

export default function Assembly() {
  const containers = useRef({})
  useEffect(() => {
    axios.get("/api/wetlab/container/read").then(({data : {data}}) => {
      containers.current = data.reduce((acc, x) => ({...acc, [x.id]: x}), {})
    })
  }, [])
  return (
    <SampleDataGrid
      api={{
        create: "/api/wetlab/protocols/assembly/create",
        read: "/api/wetlab/protocols/assembly/read",
        update: "/api/wetlab/protocols/assembly/update",
        delete: "/api/wetlab/protocols/assembly/discard"}}
      actions={[
        {
          label: "Step by Step",
          icon: <FormatListNumberedIcon />,
          multiple: true,
          Form: Protocol,
        }
      ]}
      columns={[
        {
          field: 'completed',
          headerName: 'Done',
          width: 40,
          editable: false,
          type: "boolean",
          valueGetter: (_, row) => !!row.time_stop
        },
        {
          field: 'product',
          headerName: 'Product',
          width: 120,
          editable: false,
          valueGetter: (_, row) => row.product?.name,
          sortComparator: sampleNameComparator,
          renderCell: ({row}) => row.product && <SampleNameAndBadge sample={row.product} />,
        },
        {
          field: 'fragments',
          headerName: 'Fragments',
          flex: 1,
          editable: false,
          renderCell: params => 
            params.row.fragments && 
            <List sx={{p: 0, display: "flex", flexDirection: "row"}}>
              {params.row.fragments.map(f => 
                <ListItem key={f.id}>
                  <Tooltip title={
                    <>
                      <div>{f.pmol && `${f.pmol} pmol`}</div>
                      <div>{f.location_box && `${containers.current[f.location_box]?.name}, #${f.location_pos}`}</div>
                      <div>{f.date && moment(f.date).format("M/D/YYYY")}</div>
                      <div>{f.concentration && `${(f.concentration / 1000).toLocaleString("en-US", {maximumFractionDigits: 1})}ng/μL`}</div>
                      <div>{f.description}</div>
                    </>
                  }>
                    <Chip
                      key={f.id}
                      size="small"
                      variant="outlined"
                      label={f.name}
                    />
                  </Tooltip>
                </ListItem>
              )}
            </List>
        },
        {
          field: 'method',
          headerName: 'Method',
          width: 120,
          editable: false,
        },
        {
          field: 'volume',
          headerName: 'μL',
          width: 60,
          editable: true,
        },
      ]}
      initialState={{
        sorting: {
          sortModel: [
            { field: "completed", sort: "asc" },
            { field: "product", sort: "asc" },
          ],
        },
      }}
    />
  )
}
